import {
  HighLowTripleLineChart,
  Icon,
  typographyV2,
} from '@toggle/design-system';
import styled from 'styled-components';

import { PriceMovementLegend } from '~/components/price-movement/components/price-movement-legend/PriceMovementLegend';

export const StyledTextDefaultSpan = styled.span`
  color: var(--text-default);
  ${typographyV2.titleBase};
`;

export const StyledTextPrimarySpan = styled.span`
  color: var(--text-primary);
`;

export const IconStyledCustomAnimation = styled(Icon)<{
  $expanded: boolean;
}>`
  flex-shrink: 0;
  transition: transform 0.4s cubic-bezier(0.75, 0.02, 0.5, 1);
  display: block;
  max-width: 100%;
  ${({ $expanded }) => `transform: rotate(${$expanded ? 90 : 0}deg)`}
`;

export const LoadingSkeletonWrapper = styled.div``;

export const loadingSkeletonAreas = [
  {
    styles: {
      width: '100%',
      height: '293px',
      borderRadius: '8px',
    },
  },
];

export const ChartOverrides = styled.div`
  ${HighLowTripleLineChart.Styled.HighLowTripleLineChartRoot} {
    min-height: 250px;
    margin-bottom: 30px;
  }

  ${PriceMovementLegend.Styled.LegendLabel} {
    ${typographyV2.bodyXs};
  }
`;
